import {Menubar} from 'primereact/menubar';
import {Button} from 'primereact/button';
import React, { useEffect, useState } from 'react';
import { useNavigate} from "react-router-dom";
import { authWithBackend } from './AuthWithBackend.js';
import InAppAgentWidget from './InAppAgentWidget';


const MenubarView = () =>  {
    const [agentDrawerOpen, setAgentDrawerOpen] = useState(false);
    const navigate = useNavigate();

    let adminAccess = (localStorage.getItem('adminAccess') === 'true') ? true:false
    const topMenuTemplate = (item, options) => (
        <Button
            label={item.label}
            icon={item.icon}
            size="small"
            rounded
            outlined
            severity="info"
            style={{ margin: '0 4px', fontWeight: 'bold', fontSize: '16px', backgroundColor: '#f8f9fa' }}
            pt={{
                label: { style: { fontWeight: 'bold', fontSize: '16px' } },
                icon: { style: { fontSize: '16px', backgroundColor: 'transparent' } }
            }}
            onClick={(e) => options.onClick(e)}
        >
            {item.items && <i className="pi pi-angle-down" style={{ marginLeft: '6px', fontSize: '14px', fontWeight: 'bold', backgroundColor: 'transparent' }} />}
        </Button>
    );
    const items = [
        {
            label: 'Dashboard',
            icon: 'pi pi-fw pi-chart-bar',
            template: topMenuTemplate,
            command: () => {window.location ='/'}
        },
        {   
            label: 'Cash Entries',
            command: () => {window.location = '/cash'} ,
            icon: 'pi pi-fw pi-wallet',
            template: topMenuTemplate
        },
        {   
            label: 'Cash Flow',
            command: () => {window.location = '/flow'} ,
            icon: 'pi pi-fw pi-table',
            template: topMenuTemplate
        },
        {
            label: 'Admin',
            icon: 'pi pi-fw pi-cog',
            visible: adminAccess,
            template: topMenuTemplate,
            items: [
                    {   
                        label: 'Import',
                        command: () => {window.location = '/import'} ,
                        icon: 'pi pi-fw pi-file-import'
                    },
                    {   
                        label: 'Accounts',
                        command: () => {window.location = '/account'} ,
                        icon: 'pi pi-fw pi-wrench'
                    },
                    {   
                        label: 'Categories',
                        command: () => {window.location = '/category'} ,
                        icon: 'pi pi-fw pi-wrench'
                    },
                    {   
                        label: 'Keywords',
                        command: () => {window.location = '/keyword'} ,
                        icon: 'pi pi-fw pi-wrench'
                    },
                    {   
                        label: 'Estimates',
                        command: () => {window.location = '/estimate'} ,
                        icon: 'pi pi-fw pi-wrench'
                    },
                    {   
                        label: 'Users',
                        command: () => {window.location = '/user'} ,
                        icon: 'pi pi-fw pi-wrench'
                    },
                    {
                        label: 'About',
                        command: () => {window.location ='/about'},
                        icon: 'pi pi-fw pi-info-circle'
                    },
                ]
        }
    ]
    useEffect(() => {
        authWithBackend();
        const handleOpenAgent = () => setAgentDrawerOpen(true);
        window.addEventListener('open-inapp-agent', handleOpenAgent);
        return () => window.removeEventListener('open-inapp-agent', handleOpenAgent);
    }, [])

    const start = (
        <img
            alt="logo"
            src="./logo.gif"
            style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                marginRight: '6px',
                backgroundColor: '#f8f9fa',
                mixBlendMode: 'multiply',
                filter: 'brightness(1.03) contrast(1.05)'
            }}
        />
    );
    const end = 
        <div>
            <table><tbody><tr>
                <td style={{paddingRight:'8px'}}>
                    <Button
                        label="Ask AI"
                        icon="pi pi-comments"
                        size="small"
                        rounded
                        outlined
                        severity="info"
                        style={{ fontWeight: 'bold', fontSize: '16px', backgroundColor: '#f8f9fa' }}
                        pt={{
                            label: { style: { fontWeight: 'bold', fontSize: '16px' } },
                            icon: { style: { fontSize: '16px', backgroundColor: 'transparent' } }
                        }}
                        onClick={() => setAgentDrawerOpen(true)}
                    />
                </td>
                <td>
                    <img alt="user avatar" src={localStorage.getItem('loggedInUserPicture')} style={{width:'29px',height:'29px', borderRadius:'50%'}}/>  
                </td>
                <td>
                    <Button icon="pi pi-sign-out" rounded text severity="secondary" aria-label="User"  iconPos="bottom" onClick={() => navigate("/login")}/>
                </td>
            </tr></tbody></table>
        </div>
    return(
        <div>
            <Menubar
                model={items}
                start={start}
                end={end}
                style={{ backgroundColor: '#f8f9fa' }}
                pt={{
                    action: { style: { color: '#0288D1' } },
                    label: { style: { fontWeight: 'bold', fontSize: '16px', color: '#0288D1' } },
                    icon: { style: { fontSize: '16px', color: '#0288D1', backgroundColor: 'transparent' } }
                }}
            />
            <InAppAgentWidget
                visible={agentDrawerOpen}
                onToggle={(openState) => setAgentDrawerOpen(openState)}
            />
        </div>
    )
    
};

export default MenubarView;

